import { ReactElement } from 'react';
import { FreeAccessContainer } from '../../../modules/freeAccess/containers/freeAccess.container';

export const FreeAccessViewImageView = (): ReactElement => <FreeAccessContainer />;
